import { Api } from '../api/schemas/schema'
import { msalInstance } from '../Root'

export const api = (accessToken: string) => {
   return new Api({
      baseUrl: process.env.REACT_APP_API_URL,
      baseApiParams: { headers: { Authorization: `Bearer ${accessToken}` } },
      customFetch: async (url, init) => {
         const response = await fetch(url, init)
         if (response.status === 401) {
            msalInstance.logoutRedirect()
            return Promise.reject('Unauthorized')
         }
         return response
      },
   }).api
}
